import { render, staticRenderFns } from "./ListPackage.vue?vue&type=template&id=0c71149a&scoped=true"
import script from "./ListPackage.vue?vue&type=script&lang=ts"
export * from "./ListPackage.vue?vue&type=script&lang=ts"
import style0 from "./ListPackage.vue?vue&type=style&index=0&id=0c71149a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71149a",
  null
  
)

export default component.exports